<template>
  <div
    :style="{
      left: `${leftPosition}px`,
    }"
    class="timeline-show-card-button"
  >
    <div
      class="show-card-button-icon pt"
      @click="handleClickEvent"
    >
      <em
        :style="getCustomIconStyle(iconPath('plus'))"
        class="custom-icons"
      />
    </div>
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';
export default {
  name: 'TimelineShowCardButton',
  mixins: [customIconsMixin],
  props: {
    leftPosition: {
      type: Number,
      required: true,
    },
  },
  emits: ['showCard'],
  methods: {
    handleClickEvent() {
      this.$emit('showCard');
    },
  },
};
</script>

<style lang="scss">
.timeline-show-card-button {
  @apply absolute
    flex
    justify-center
    items-center
    w-9
    h-8
    top-1
    opacity-0
    transition-opacity
    -translate-x-1/2;

  .show-card-button-icon {
    @apply flex
      items-center
      justify-center
      w-7
      h-7
      rounded-md
      bg-icon-bg
      border
      border-dotted
      border-icon-bg;

    .custom-icons {
      @apply bg-icon-default;
    }

    &:hover {
      @apply border-important-border;

      .custom-icons {
        @apply bg-icon-hover;
      }
    }
  }
}
</style>
